"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.all = all;
exports.bbox = bbox;
exports.tile = tile;

var _proj = require("./proj.js");

/**
 * @module ol/loadingstrategy
 */

/**
 * Strategy function for loading all features with a single request.
 * @param {import("./extent.js").Extent} extent Extent.
 * @param {number} resolution Resolution.
 * @return {Array<import("./extent.js").Extent>} Extents.
 * @api
 */
function all(extent, resolution) {
  return [[-Infinity, -Infinity, Infinity, Infinity]];
}
/**
 * Strategy function for loading features based on the view's extent and
 * resolution.
 * @param {import("./extent.js").Extent} extent Extent.
 * @param {number} resolution Resolution.
 * @return {Array<import("./extent.js").Extent>} Extents.
 * @api
 */


function bbox(extent, resolution) {
  return [extent];
}
/**
 * Creates a strategy function for loading features based on a tile grid.
 * @param {import("./tilegrid/TileGrid.js").default} tileGrid Tile grid.
 * @return {function(import("./extent.js").Extent, number, import("./proj.js").Projection): Array<import("./extent.js").Extent>} Loading strategy.
 * @api
 */


function tile(tileGrid) {
  return (
    /**
     * @param {import("./extent.js").Extent} extent Extent.
     * @param {number} resolution Resolution.
     * @param {import("./proj.js").Projection} projection Projection.
     * @return {Array<import("./extent.js").Extent>} Extents.
     */
    function (extent, resolution, projection) {
      var z = tileGrid.getZForResolution((0, _proj.fromUserResolution)(resolution, projection));
      var tileRange = tileGrid.getTileRangeForExtentAndZ((0, _proj.fromUserExtent)(extent, projection), z);
      /** @type {Array<import("./extent.js").Extent>} */

      var extents = [];
      /** @type {import("./tilecoord.js").TileCoord} */

      var tileCoord = [z, 0, 0];

      for (tileCoord[1] = tileRange.minX; tileCoord[1] <= tileRange.maxX; ++tileCoord[1]) {
        for (tileCoord[2] = tileRange.minY; tileCoord[2] <= tileRange.maxY; ++tileCoord[2]) {
          extents.push((0, _proj.toUserExtent)(tileGrid.getTileCoordExtent(tileCoord), projection));
        }
      }

      return extents;
    }
  );
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBSUE7O0FBSkE7Ozs7QUFNQTs7Ozs7OztBQU9NLFNBQVVBLEdBQVYsQ0FBY0MsTUFBZCxFQUFzQkMsVUFBdEIsRUFBZ0M7RUFDcEMsT0FBTyxDQUFDLENBQUMsQ0FBQ0MsUUFBRixFQUFZLENBQUNBLFFBQWIsRUFBdUJBLFFBQXZCLEVBQWlDQSxRQUFqQyxDQUFELENBQVA7QUFDRDtBQUVEOzs7Ozs7Ozs7O0FBUU0sU0FBVUMsSUFBVixDQUFlSCxNQUFmLEVBQXVCQyxVQUF2QixFQUFpQztFQUNyQyxPQUFPLENBQUNELE1BQUQsQ0FBUDtBQUNEO0FBRUQ7Ozs7Ozs7O0FBTU0sU0FBVUksSUFBVixDQUFlQyxRQUFmLEVBQXVCO0VBQzNCO0lBQ0U7Ozs7OztJQU1BLFVBQVVMLE1BQVYsRUFBa0JDLFVBQWxCLEVBQThCSyxVQUE5QixFQUF3QztNQUN0QyxJQUFNQyxDQUFDLEdBQUdGLFFBQVEsQ0FBQ0csaUJBQVQsQ0FDUiw4QkFBbUJQLFVBQW5CLEVBQStCSyxVQUEvQixDQURRLENBQVY7TUFHQSxJQUFNRyxTQUFTLEdBQUdKLFFBQVEsQ0FBQ0sseUJBQVQsQ0FDaEIsMEJBQWVWLE1BQWYsRUFBdUJNLFVBQXZCLENBRGdCLEVBRWhCQyxDQUZnQixDQUFsQjtNQUlBOztNQUNBLElBQU1JLE9BQU8sR0FBRyxFQUFoQjtNQUNBOztNQUNBLElBQU1DLFNBQVMsR0FBRyxDQUFDTCxDQUFELEVBQUksQ0FBSixFQUFPLENBQVAsQ0FBbEI7O01BQ0EsS0FDRUssU0FBUyxDQUFDLENBQUQsQ0FBVCxHQUFlSCxTQUFTLENBQUNJLElBRDNCLEVBRUVELFNBQVMsQ0FBQyxDQUFELENBQVQsSUFBZ0JILFNBQVMsQ0FBQ0ssSUFGNUIsRUFHRSxFQUFFRixTQUFTLENBQUMsQ0FBRCxDQUhiLEVBSUU7UUFDQSxLQUNFQSxTQUFTLENBQUMsQ0FBRCxDQUFULEdBQWVILFNBQVMsQ0FBQ00sSUFEM0IsRUFFRUgsU0FBUyxDQUFDLENBQUQsQ0FBVCxJQUFnQkgsU0FBUyxDQUFDTyxJQUY1QixFQUdFLEVBQUVKLFNBQVMsQ0FBQyxDQUFELENBSGIsRUFJRTtVQUNBRCxPQUFPLENBQUNNLElBQVIsQ0FDRSx3QkFBYVosUUFBUSxDQUFDYSxrQkFBVCxDQUE0Qk4sU0FBNUIsQ0FBYixFQUFxRE4sVUFBckQsQ0FERjtRQUdEO01BQ0Y7O01BQ0QsT0FBT0ssT0FBUDtJQUNEO0VBbkNIO0FBcUNEIiwibmFtZXMiOlsiYWxsIiwiZXh0ZW50IiwicmVzb2x1dGlvbiIsIkluZmluaXR5IiwiYmJveCIsInRpbGUiLCJ0aWxlR3JpZCIsInByb2plY3Rpb24iLCJ6IiwiZ2V0WkZvclJlc29sdXRpb24iLCJ0aWxlUmFuZ2UiLCJnZXRUaWxlUmFuZ2VGb3JFeHRlbnRBbmRaIiwiZXh0ZW50cyIsInRpbGVDb29yZCIsIm1pblgiLCJtYXhYIiwibWluWSIsIm1heFkiLCJwdXNoIiwiZ2V0VGlsZUNvb3JkRXh0ZW50Il0sInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInNyYy9sb2FkaW5nc3RyYXRlZ3kuanMiXSwic291cmNlc0NvbnRlbnQiOltudWxsXX0=